export const SET_TERMO_BUSCA_GERAL_PLATAFORMA = 'SET_TERMO_BUSCA_GERAL_PLATAFORMA'
